var nil = {};

export { nil as __exports };
//# sourceMappingURL=nil.js.map
